import type { CelebrityResult } from "./types";

export const zachJohnson: CelebrityResult = {
  slug: "zach-johnson",
  firstName: "Zach",
  lastName: "Johnson",
  roleLines: ["Professional Golfer", "RESTORE® client", "4,805 Grafts"],
  headlineLines: ["Mastered", "Balding"],
  intro: [
    "As a 12-time PGA TOUR winner, Zach Johnson is no stranger to having all eyes on him. But through the years, he began to notice quite a bit of hair loss. While it didn't cause him trouble on the green, it did shake his confidence when he removed his hat after a round.",
    "Like many others, he learned about RESTORE® from Brian Urlacher.",
  ],
  heroBannerImage: {
    src: "/endorser-banners/johnson_website_banner_1920x800_v1.webp",
    alt: "Zach Johnson RESTORE hair restoration results banner",
  },
  heroBannerImageMobile: {
    src: "/endorser-banners/johnson_website_mobile_800x879_v1.webp",
    alt: "Zach Johnson RESTORE hair restoration results banner",
  },
  heroBackground: "/img/r/wp-2023-12-restore-zachjohnson-after-desktop-1-1.webp",
  heroLayout: "diagonal-right",
  heroMinHeight: "700px",
  posterImage: {
    src: "/img/r/wp-2024-08-restore-zachjohnson-1-768x512-3.webp",
    alt: "Zach Johnson RESTORE Hair Results",
  },
  heroBeforeAfter: {
    src: "/img/r/wp-2023-12-zj-before-after-v1.webp",
    alt: "Zach Johnson before and after hair transplant",
  },
  story: {
    headingPrefix: "Zach Johnson",
    headingSuffix: "Hair Transplant Story & Bio",
    image: {
      src: "/img/r/wp-2022-09-zach-johnson-video-bg-1.webp",
      alt: "Zach Johnson hair transplant story",
    },
    paragraphs: [
      "As a 12-time PGA TOUR winner, Zach Johnson is no stranger to having all eyes on him. He has won three PGA tour events: The Masters, The AT&T Classic, and the Valero Texas Open, but through the years, he began to notice quite a bit of hair loss. While it didn't cause him trouble on the green against Tiger Woods, it did shake his confidence when he removed his hat after a round. Originally from Iowa, Zach began his love of golf and sports in high school. After playing in the Ryder Cup five times and winning in 2016, Zach had racked up an impressive bio.",
      "Like many others, he learned about RESTORE® from Brian Urlacher. After seeing his before and after photos, Zach was sold! He recalls being amazed at how easy the FUE hair transplant was. \u201cMy results have been like my sports career \u2013 I just keep getting better every year!\u201d Zach said. Since his procedure, Zach is proud of his new hair. He credits his regained youth to RESTORE's magic and is excited about 2024 and beyond.",
    ],
  },
  gallery: {
    heading: "Zach Johnson, PGA Tour Worthy Hair",
    images: [
      {
        src: "/img/r/wp-2021-12-zach-slider1-1.webp",
        alt: "Zach Johnson RESTORE Hair",
      },
      {
        src: "/img/r/wp-2021-12-zach-slider3-1.webp",
        alt: "Zach Johnson RESTORE Hair",
      },
      {
        src: "/img/r/wp-2021-12-zach-slider4-1-300x274.webp",
        alt: "Zach Johnson RESTORE Hair",
      },
    ],
  },
  qa: {
    heading: "Zach Johnson Hair Q&A",
    items: [
      {
        image: {
          src: "/img/r/wp-2021-12-zach-qa1-1.webp",
          alt: "Zach Johnson RESTORE Hair Questions",
        },
        question: "What can people expect during a hair transplant?",
        answer:
          "You've got blankets, you've got food, you've got a TV. You can have a conversation or even take a nap. I felt like I was home on the couch.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-zach-qa2-1.webp",
          alt: "Zach Johnson RESTORE Hair Questions",
        },
        question: "How did you find RESTORE?",
        answer:
          "I got a text message from THE Brian Urlacher. I looked on the website and next thing you know I'm on my way to Chicago.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-zach-qa3-1.webp",
          alt: "Zach Johnson RESTORE Hair Questions",
        },
        question: "What advice do you have for other men who are experiencing hair loss?",
        answer:
          "Don't wait! You'll look back and wonder what took you so long. RESTORE will have you looking - and feeling - like you're in your 20s again.",
      },
    ],
  },
  seoH1: "ZACH JOHNSON",
  seo: {
    title: "Zach Johnson Hair Transplant Results | RESTORE Hair",
    description:
      "Learn why Zach Johnson came to RESTORE to get his hair restoration. See behind the scene photos and videos directly from Zach.",
  },
};
